<template>
  <section class="evento-lux">

  <div ref="seccionBloque1" class="bloque-evento" aria-label="Ceremonia">
      <img class="icono-lazo" src="@/assets/ig.png" alt="Icono Ceremonia" />
      
      <p class="hora-top">5:30 P.M.</p>
      <h3 class="titulo-editorial">RELIGIOUS CEREMONY</h3>
      <p class="lugar-luxury">Parroquia La Inmaculada Concepción</p>
      <p class="direccion-editorial">
       Tapiceros 1680, Industrial <br />
       Mexicali, Baja California.
      </p>

   
      <a
        ref="btn1"
        class="btn-editorial-rosa"
        href="https://maps.app.goo.gl/Wb2Mgi3ojPgjFUNF7"
        target="_blank"
        rel="noopener"
      >
        GOOGLE MAPS
        <span class="sheen"></span>
      </a>
    </div>

    <div class="espaciador-bloques"></div>


    <div ref="seccionBloque2" class="bloque-evento" aria-label="Recepción">
      <img class="icono-lazo" src="@/assets/c.png" alt="Icono Recepción" />
      
      <p class="hora-top">7:00 P.M.</p>
      <h3 class="titulo-editorial">RECEPTION</h3>
      <p class="lugar-luxury">Salón Blanc</p>
      <p class="direccion-editorial">
       Calz Macristy de Hermosillo 949, República Mexicana <br />
      Mexicali, Baja California.
      </p>


      <a
        ref="btn2"
        class="btn-editorial-rosa"
        href="https://maps.app.goo.gl/cRgHxBdLiMyPtvFa8"
        target="_blank"
        rel="noopener"
      >
        GOOGLE MAPS
        <span class="sheen"></span>
      </a>
    </div>

    
  </section>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'EventoSectionLuxuryScroll',
  setup() {
    // Refs principales renombradas para aislamiento estricto
    const seccionBloque1 = ref(null)
    const seccionBloque2 = ref(null)
    const btn1 = ref(null)
    const btn2 = ref(null)

    let ctx1; // Contexto GSAP para el bloque 1
    let ctx2; // Contexto GSAP para el bloque 2
    let animPetalos; // Guardado de la animación infinita de los pétalos

    const crearAnimacionServidor = (bloqueEl, btnEl, esBloqueUno = true) => {
      if (!bloqueEl || !btnEl) return

      // Usamos el selector local scoped para que no busque clases fuera de este bloque específico
      const $ = gsap.utils.selector(bloqueEl)
      
      const lazo = $('.icono-lazo')
      const hora = $('.hora-top')
      const titulo = $('.titulo-editorial')
      const lugar = $('.lugar-luxury')
      const dir = $('.direccion-editorial')
      const imgLugar = $('.imagen-lugar-wrapper')

      // Creamos la línea de tiempo principal
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: bloqueEl,
          start: 'top 70%', // Sincronización perfecta para la altura de lectura en móviles
          toggleActions: 'play none none reverse' // Permite re-animar limpiamente al regresar el scroll
        },
        defaults: { ease: 'power3.out', duration: 0.6 }
      })

      // Forzar estados limpios con fromTo para evitar parpadeos en renderizados móviles
      tl.fromTo(bloqueEl, { opacity: 0, y: 45 }, { opacity: 1, y: 0, duration: 0.7 })
        .fromTo(lazo, { opacity: 0, scale: 0.6, y: -20 }, { opacity: 1, scale: 1, y: 0 }, '-=0.45')
        .fromTo(hora, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, '-=0.4')
        .fromTo(titulo, { opacity: 0, letterSpacing: '0.02em', y: 20 }, { opacity: 1, letterSpacing: 'initial', y: 0 }, '-=0.4')
        .fromTo(lugar, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, '-=0.4')
        .fromTo(dir, { opacity: 0, y: 20 }, { opacity: 1, y: 0 }, '-=0.3')
        
        // Animación cinemática de la tarjeta de imagen
        .fromTo(imgLugar, 
          { opacity: 0, scale: 0.75, rotate: esBloqueUno ? -5 : 5, y: 35 }, 
          { opacity: 1, scale: 1, rotate: 0, y: 0, duration: 0.8, ease: 'back.out(1.3)' }, 
          '-=0.3'
        )
        .fromTo(btnEl, { opacity: 0, y: 15, scale: 0.93 }, { opacity: 1, y: 0, scale: 1, duration: 0.4 }, '-=0.3')

      // Efecto brillo Premium (Sheen) en el botón al entrar al Viewport
      ScrollTrigger.create({
        trigger: bloqueEl,
        start: 'top 70%',
        onEnter: () => {
          const shine = btnEl.querySelector('.sheen')
          if (!shine) return
          gsap.fromTo(
            shine,
            { xPercent: -120, opacity: 0 },
            { xPercent: 140, opacity: 1, duration: 1.1, ease: 'power2.inOut', delay: 0.9 }
          )
        }
      })
    }

    onMounted(async () => {
      await nextTick()

      // Inicializar Bloque 1 bajo su propio contexto seguro
      if (seccionBloque1.value) {
        ctx1 = gsap.context(() => {
          crearAnimacionServidor(seccionBloque1.value, btn1.value, true)
        }, seccionBloque1.value)
      }

      // Inicializar Bloque 2 bajo su propio contexto seguro
      if (seccionBloque2.value) {
        ctx2 = gsap.context(() => {
          crearAnimacionServidor(seccionBloque2.value, btn2.value, false)
        }, seccionBloque2.value)
      }

      // Animación continua y orgánica de pétalos flotantes a nivel global del componente
      animPetalos = gsap.to('.petalo-flotante', {
        y: '+=12',
        rotation: '+=6',
        duration: 3.8,
        repeat: -1,
        yoyo: true,
        ease: 'sine.inOut',
        stagger: 0.35
      })
    })

    onUnmounted(() => {
      // Revertir de raíz todos los contextos creados para evitar fugas de memoria
      if (ctx1) ctx1.revert()
      if (ctx2) ctx2.revert()
      if (animPetalos) animPetalos.kill()
    })

    return { seccionBloque1, seccionBloque2, btn1, btn2 }
  }
}
</script>
<style scoped>
/* ==================== CONFIGURACIÓN ESTILO EDITORIAL COINCIDENTE ==================== */
.evento-lux {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding: 60px 20px 70px;
    display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
}

/* ==================== BLOQUES CONTENEDORES CONTRAÍDOS ==================== */
.bloque-evento {
  width: min(100%, 420px);
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 2;
}

.espaciador-bloques {
  height: 70px;
  width: 100%;
}
.icono-lazo1 {
  width: auto;
  height: clamp(160px, 29vh, 260px) !important;
  display: block;
  margin: 0 auto 18px;
  object-fit: contain;
  filter: drop-shadow(0 4px 10px rgba(225, 180, 185, 0.25));
}
.icono-lazo {
  width: auto;
  height: clamp(60px, 20vh, 150px) !important;
  display: block;
  margin: 0 auto 18px;
  object-fit: contain;

  filter: drop-shadow(0 4px 10px rgba(225, 180, 185, 0.25));
}

/* ==================== IMAGEN CIRCULAR LUXURY (NUEVA SECCIÓN COINCIDENTE) ==================== */
.imagen-lugar-wrapper {
  width: min(65vw, 220px);
  height: min(65vw, 220px);
  border-radius: 50%;
  overflow: hidden;
  margin: 0 auto 28px; /* Separación simétrica perfecta */
  background: #fff;
  border: 3px solid #ffffff; /* Fino marco blanco estilo editorial de alta gama */
  will-change: transform, opacity;
}

.imagen-lugar {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.shadow-luxury-img {
  box-shadow: 
    0 10px 30px rgba(225, 180, 185, 0.3),
    0 2px 8px rgba(0, 0, 0, 0.04);
}

/* ==================== TIPOGRAFÍAS DE ALTA GAMA ==================== */
.hora-top {
  font-family: 'Montserrat', sans-serif;
  font-size: clamp(20px, 4.5vw, 24px);
  font-weight: 400;
  color: #333333;
  margin: 0 0 4px 0;
  letter-spacing: 0.05em;
}

.titulo-editorial {
  font-family: 'Playfair Display', serif;
  font-weight: 400;
  font-size: clamp(38px, 9vw, 46px);

  color: #071339; /* Deep Satin Navy Blue */


  
font-weight: 800;
letter-spacing: 0.5px;

text-shadow:
  0 1px 0 rgba(255,255,255,.25),
  0 2px 4px rgba(0,0,0,.25),
  0 0 10px rgba(93,127,224,.25);
  margin: 0 0 12px 0;
  letter-spacing: 0.12em;
  line-height: 1.1;
}

.lugar-luxury {
  font-family: 'padres', serif;
  font-size: clamp(26px, 6vw, 32px);
  color: #1a1a1a;
  font-weight: 500;
  margin: 0 0 10px 0;
  line-height: 1.2;
}

.direccion-editorial {
  font-family: 'Montserrat', sans-serif;
  font-style: normal;
  color: #555555;
  font-size: clamp(14px, 3.2vw, 15px);
  line-height: 1.6;
  margin: 0 auto 20px;
  max-width: 85%;
  letter-spacing: 0.02em;
}

/* ==================== BOTÓN DE DISEÑO FLUSH ==================== */
.btn-editorial-rosa {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: min(100%, 260px);
  padding: 13px 28px;
  border-radius: 12px;
  background-color:  #071339;;
;
  color: #ffffff;
  text-decoration: none;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  box-shadow: 0 6px 20px rgba(222, 176, 182, 0.35);
  transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275), box-shadow 0.2s ease;
  border: none;
  overflow: hidden;
}

.btn-editorial-rosa:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(222, 176, 182, 0.5);
}

.btn-editorial-rosa:active {
  transform: translateY(0);
}

.btn-editorial-rosa .sheen {
  position: absolute;
  top: -30%;
  left: -30%;
  width: 50%;
  height: 160%;
  transform: rotate(25deg);
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
  mix-blend-mode: screen;
}

/* ==================== PÉTALOS ACENTUADOS A LOS COSTADOS ==================== */
.petalo-flotante {
  position: absolute;
  width: min(22vw, 90px);
  height: auto;
  object-fit: contain;
  pointer-events: none;
  opacity: 0.85;
  z-index: 1;
}

.petalo-izq-1 {
  top: 9vh;
  left: -4vw;
  transform: rotate(-15deg);
}

.petalo-der-1 {
  top: 62vh;
  right: -5vw;
  transform: rotate(20deg) scaleX(-1);
}

/* ===== ESCENA FINAL ===== */
.lux-escena-final {
  position: relative;
  width: 100%;
  display: grid;
  place-items: center;
  margin-top: 50px;  
  overflow: visible;
}

.lux-degradado {
  width: 100%;
  height: 120px;
  background: linear-gradient(
    to top,
    #fdf2f3 0%,
    rgba(253, 242, 243, 0.539) 40.,
    rgba(253, 242, 243, 0) 100%
  );
}

.lux-flores {
  position: absolute;
  bottom: 0;
  left: 90%;
  transform: translateX(-50%) rotate(-44deg);
  width: 100%;
  max-width: 520px;
  opacity: 0.5 !important;
  pointer-events: none;
  filter: drop-shadow(0 -4px 12px rgba(225, 180, 185, 0.15));
  opacity: 0.95;
}

@media (prefers-reduced-motion: reduce) {
  * {
    transition: none !important;
    animation: none !important;
  }
}
</style>